import { usePermissions } from "react-admin";
import {
  ProLogsPermissions,
  ProtectedEntity,
  ProtectedEntityDtos,
} from "../auth/permissions";
import { FieldPermissionGrantDto } from "../data/service-proxies";

export const useFieldPermissions = (
  entity: ProtectedEntity,
  dtoSelector: (dtos: ProtectedEntityDtos) => string | undefined
): { fieldPermissions: FieldPermissionGrantDto[] } => {
  const { permissions } = usePermissions<ProLogsPermissions>();
  if (!permissions) {
    return { fieldPermissions: [] };
  }

  const { fieldPermissions } = permissions;
  if (!fieldPermissions) {
    return { fieldPermissions: [] };
  }

  return {
    fieldPermissions:
      fieldPermissions
        .find((x) => x.entity === entity.entityName)
        ?.groups?.find((x) => x.group === dtoSelector(entity.dtos))
        ?.permissions ?? [],
  };
};
